// modules
import * as R from 'ramda'
// actions
import {
  RESET_WAPP_STACK,
  PUSH_WAPP_STACK,
  POP_WAPP_STACK,
  SET_CURRENT_IN_WAPP_STACK,
} from './wappStack.action'
// setup
import { getState } from '../../setup/redux'

// state
const initialState = {
  stack: [],
  current: {},
}

// views
export const wappStackTopView = () =>
  R.compose(R.last, R.path(['main', 'wappStack', 'stack']))(getState())

export const wappStackCurrentView = () =>
  R.path(['main', 'wappStack', 'current'], getState())

const reducers = {
  [RESET_WAPP_STACK]: () => initialState,

  [PUSH_WAPP_STACK]: (state, data) =>
    R.over(R.lensProp('stack'), R.append(data), state),

  [POP_WAPP_STACK]: state => R.over(R.lensProp('stack'), R.dropLast(1), state),

  [SET_CURRENT_IN_WAPP_STACK]: (state, current) => ({ ...state, current }),
}

export default (state = initialState, { type, payload }) =>
  reducers[type] ? reducers[type](state, payload) : state
